export default {"src":"/_next/static/media/Wim-Van-Cappellen3.d7b843be.JPG","height":1170,"width":1560};